'use strict';

/* Views */
import AttendanceReport from './report/attendance-report.component';
import SignInSheet from './sign-in-sheet/sign-in-sheet.component';

/* Services */
import AttendanceService from '../../services/attendance/attendance.service';

/* Components */
import signInSheetFormComponent from '../../components/sign-in-sheet-form/sign-in-sheet-form.component';

export default angular.module('conduuApp.attendance', [AttendanceReport, SignInSheet, AttendanceService,
  signInSheetFormComponent])
  .name;



// WEBPACK FOOTER //
// ./client/app/attendance/index.js